import { ICoreContext } from '@msdyn365-commerce/core-internal';
import MsDyn365 from '@msdyn365-commerce/core';

let currentScreenSize: number | null = null;
let resizeHandler: (() => void) | null = null;

const calculateScreenSize = (width: number): number => {
    if (width < 767) {
        // Mobile
        return 1;
    } else if (width < 1280) {
        // iPad
        return 2;
    } else if (width >= 1280 && width < 1476) {
        // Desktop
        return 3;
    } else if (width >= 1476 && width < 1920) {
        // Mid-desktop
        return 4;
    } else if (width >= 1920) {
        // Large-desktop
        return 5;
    } else {
        return 4; // fallback
    }
};

export const _getScreenSize = (context: ICoreContext): number => {
    // Always return 1 for server-side rendering
    if (!MsDyn365.isBrowser) {
        return 1;
    }

    if (typeof window !== 'undefined' && window.innerWidth) {
        // Initialize currentScreenSize if not already done
        if (currentScreenSize === null) {
            currentScreenSize = calculateScreenSize(window.innerWidth);

            // Attach resize listener once
            resizeHandler = () => {
                const newSize = calculateScreenSize(window.innerWidth);
                if (newSize !== currentScreenSize) {
                    currentScreenSize = newSize;
                }
            };

            window.addEventListener('resize', resizeHandler);
        }

        return currentScreenSize;
    }

    return 3; // Default to desktop if all else fails
};

export const cleanupScreenSizeListener = (): void => {
    if (MsDyn365.isBrowser && resizeHandler) {
        window.removeEventListener('resize', resizeHandler);
        resizeHandler = null;
        currentScreenSize = null;
    }
};
